export const shouldShowGeneration = (fotovoltaica: string, generationAvailable?: boolean): boolean =>
  fotovoltaica === 'si' && generationAvailable !== false;

export const shouldShowSelfConsumption = (fotovoltaica: string, generationAvailable?: boolean): boolean =>
  shouldShowGeneration(fotovoltaica, generationAvailable);

export const shouldExpandNetworkCard = (fotovoltaica: string): boolean => fotovoltaica !== 'si';

export const isGenerationAvailableForTab = (
  currentTab: string,
  generationAvailable?: boolean,
  hasHistoricalGenerationGap?: boolean,
): boolean =>
  generationAvailable !== false && (currentTab !== 'historic' || !hasHistoricalGenerationGap);
